import React, { useState, useEffect } from "react";
import styles from "./PricingModal.module.css";

const PricingModal = ({ isOpen, onClose, plans }) => {
  if (!isOpen) return null;
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          ×
        </button>
        <div className={styles.title}>تعرفه‌ها</div>
        <p className={styles.description}>
          پکیج های ارائه شده توسط ایرلوکس به شرح زیر می باشد.
          <br />
          کلیه پکیج ها تک کاربره می باشند.
        </p>
        <div className={styles.planList}>
          {plans && (
            <>
              {plans?.map((plan) => (
                <div
                  key={plan.id}
                  className={`${styles.planCard} ${
                    plan.isPopular ? styles.popular : ""
                  }`}
                >
                  <div className={styles.planName}>{plan.name}</div>
                  <p className={styles.planTraffic}>
                    ترافیک: {plan.traffic} گیگابایت
                  </p>
                  <p className={styles.planPrice}>
                    قیمت ماهانه: {plan.price.toLocaleString("fa-IR")} تومان
                  </p>
                  {plan.features && (
                    <ul className={styles.planFeatures}>
                      {plan.features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  )}
                  <button className={styles.selectButton}>انتخاب</button>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingModal;
